var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{staticClass:"mt-12",attrs:{"hide-banner-notifications":"","fluid":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('Navbar')]},proxy:true}])},[_c('div',[_vm._t("default",function(){return [_c('router-view')]})],2),_c('v-spacer'),_c('Footer',{attrs:{"app":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }